import { getLinkedItems } from '@/components/contexts/KontentHomeConfigProvider'
import type { IContentItemsContainer } from '@kontent-ai/delivery-sdk'
import type {
	PrescriptionContainer,
	PrescriptionGroup,
	PrescriptionOption,
	PrescriptionWork,
	PrescriptionWorkBundle,
} from '../types'

const TYPE_PRESCRIPTION_GROUP = 'prescription_group'
const TYPE_PRESCRIPTION_OPTION = 'prescription_option'
const TYPE_PRESCRIPTION_WORK_BUNDLE = 'prescription_work_bundle'

const groupHasTriggeringWork = (
	group: PrescriptionGroup,
	linkedItems: IContentItemsContainer,
): boolean => {
	const children =
		getLinkedItems(group.elements.prescription_work, linkedItems) ?? []

	for (const child of children) {
		if (child.system.type === TYPE_PRESCRIPTION_WORK_BUNDLE) {
			const bundle = child as PrescriptionWorkBundle
			const innerWorks =
				getLinkedItems(
					bundle.elements.prescription_work,
					linkedItems,
				) ?? []
			for (const innerWork of innerWorks) {
				if (workHasSubtitles(innerWork)) return true
			}
		} else {
			// Standalone PrescriptionWork.
			if (workHasSubtitles(child as PrescriptionWork)) return true
		}
	}

	return false
}

const workHasSubtitles = (work: PrescriptionWork): boolean => {
	const raw = work.elements.subtitles?.value ?? ''
	return raw.trim().length > 0
}

export const hasCollectionsTrigger = (
	containers: PrescriptionContainer[],
	linkedItems: IContentItemsContainer,
): boolean => {
	for (const container of containers) {
		if (container.system.type === TYPE_PRESCRIPTION_GROUP) {
			if (
				groupHasTriggeringWork(
					container as PrescriptionGroup,
					linkedItems,
				)
			) {
				return true
			}
			continue
		}

		if (container.system.type === TYPE_PRESCRIPTION_OPTION) {
			const inner =
				getLinkedItems(
					(container as PrescriptionOption).elements.prescriptions,
					linkedItems,
				) ?? []

			for (const innerItem of inner) {
				// Studies short-circuit per PRD §10.2 — no subtitles field.
				if (innerItem.system.type === TYPE_PRESCRIPTION_GROUP) {
					if (
						groupHasTriggeringWork(
							innerItem as PrescriptionGroup,
							linkedItems,
						)
					) {
						return true
					}
				}
			}
		}
	}

	return false
}
